export default "__VITE_ASSET__DMdy8RvV__"